import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Pitch from './pages/Pitch';
import VendorApply from './pages/VendorApply';
import Dapp from './pages/Dapp';
import NotFound from './pages/NotFound';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pitch" element={<Pitch />} />
        <Route path="/vendors" element={<VendorApply />} />
        <Route path="/app" element={<Dapp />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
